export default __webpack_public_path__ + "static/HomeScreen-e294b4f9863b57c6ff7c6f99c8c87869.png";